/*
* AGP events
* Gestion
*/

import $ from "jquery";
import 'jquery-ui';
require('jquery-ui/ui/widgets/sortable');

export default class Gestion {


    init() {
        $(document).on("click", "._entete_contain", function () {
            $(this).parent().toggleClass("_open");
            $("._entete_contain").not(this).parent().removeClass("_open");
        });

    }
}